import { LitElement, html } from 'lit';
import { DebugService } from '../services/debug.service.js';
import { style } from './loading-spinner.style.js';

class RefiLoadingSpinner extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('LoadingSpinner');
    this.message = '';
  }

  static properties = {
    message: { type: String, attribute: true },
  };

  static styles = [style];

  render() {
    return html`
      <div class="grv-spinner">
        ${this.message
          ? html`
              <span aria-label="${this.message}" role="alert"
                >${this.message}</span
              >
            `
          : ''}
      </div>
    `;
  }
}

customElements.define('refi-loading-spinner', RefiLoadingSpinner);
